export default __webpack_public_path__ + "9accae0.png";